import { Card } from "flowbite-react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/* 🔄 Spinner */
function Spinner({ text }) {
  return (
    <div className="flex flex-col items-center gap-3 mt-6">
      <div className="w-8 h-8 border-4 border-purple-800 border-t-transparent rounded-full animate-spin"></div>
      <p className="text-sm text-gray-600">{text}</p>
    </div>
  );
}

function Success() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const [status, setStatus] = useState("PENDING");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) return;

    let intervalId;

    const fetchStatus = async () => {
      try {
        const res = await fetch(
          `https://fitmeal-payment-api-1.onrender.com/api/payment/order-status?orderId=${orderId}`
        );

        if (!res.ok) return;

        const data = await res.json();
        setStatus(data.status);

        // Stop polling once final state is reached
        if (data.status === "CAPTURED" || data.status === "FAILED") {
          clearInterval(intervalId);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching payment status", err);
      }
    };

    // Initial call
    fetchStatus();

    // Poll every 3 seconds
    intervalId = setInterval(fetchStatus, 3000);

    return () => clearInterval(intervalId);
  }, [orderId]);

  /* ---------------- UI STATES ---------------- */
  console.log("status", status);
  const renderContent = () => {
    if (status === "PENDING") {
      return (
        <>
          <h1 className="text-2xl font-bold text-purple-700">
            Processing Payment ⏳
          </h1>
          <p className="mt-3 text-gray-600">
            We are confirming your payment. Please don’t refresh the page.
          </p>
          <Spinner text="Waiting for payment confirmation..." />
        </>
      );
    }

    if (status === "CAPTURED") {
      return (
        <>
          <h1 className="text-3xl font-bold text-green-600">
            Payment Successful 🎉
          </h1>
          <p className="mt-4 text-gray-700">
            Thank you for choosing <strong>FitMeal Workout</strong>.
          </p>
          <p className="mt-2 text-gray-600">
            Our team will contact you shortly with your plan details.
          </p>
        </>
      );
    }

    if (status === "FAILED") {
      return (
        <>
          <h1 className="text-3xl font-bold text-red-600">Payment Failed ❌</h1>
          <p className="mt-4 text-gray-700">
            Unfortunately, your payment could not be completed.
          </p>
          <p className="mt-2 text-gray-600">
            Please try again or contact support.
          </p>
        </>
      );
    }

    return null;
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <Card className="w-full max-w-md text-center">
        {renderContent()}

        <p className="mt-6 text-xs text-gray-500">
          Secured & verified by Razorpay
        </p>
      </Card>
    </div>
  );
}

export default Success;
